import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const numberFormats = {
    "nl-BE": {
        ccy: {
            minimumFractionDigits: 2,
        },
    },
};

const dateTimeFormats = {
    "nl-BE": {
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
        },
    },
    "en-US": {
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "long",
            day: "numeric",
            weekday: "long",
            hour: "numeric",
            minute: "numeric",
        },
    },
};

function loadLocaleMessages() {
    const locales = require.context(
        "../locales",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

export default new VueI18n({
    numberFormats,
    dateTimeFormats,
    locale: process.env.VUE_APP_I18N_LOCALE || "en-US",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-US",
    messages: loadLocaleMessages(),
});
